import React, { useEffect, useState } from "react";
import getAllEquipment from "./AddEquipment"; // Adjust path as needed
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Typography, CircularProgress } from "@mui/material";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import '../App.css';

function DamagedEq() {
  const [equipment, setEquipment] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchEquipmentData() {
      try {
        const data = await getAllEquipment();
        const sortedData = (data || [])
          .filter((item) => item.Damaged === true || item.Damaged === "true")
          .sort((a, b) => a.id - b.id); // Sort by id in ascending order
        setEquipment(sortedData);
      } catch (error) {
        console.error("Error fetching equipment data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchEquipmentData();
  }, []);

  if (loading) {
    return (
      <div id="progress">
        <CircularProgress />
      </div>
    );
  }

  const headers = ["id", "name", "damageDescription"];
  const itemCount = equipment.length;

  if (itemCount === 0) {
    return (
      <div>
        <Typography
          align="center"
          variant="h4"
          component="div"
          sx={{ flexGrow: 1, m: 2 }}
        >
          Damaged Equipment List
        </Typography>
        <Typography align="center" variant="h8" component="div">
          <CheckCircleOutlineOutlinedIcon /> All set. No equipment reported as damaged at this time.
        </Typography>
      </div>
    );
  }

  return (
    <div>
      <Typography
        align="center"
        variant="h4"
        component="div"
        sx={{ flexGrow: 1, m: 2 }}
      >
        Damaged Equipment List
      </Typography>
      <Typography align="center" variant="subtitle1" component="div" sx={{ mb: 2 }}>
        Total Damaged Items: {itemCount}
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableCell key={header}>
                  {header.charAt(0).toUpperCase() + header.slice(1)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {equipment.map((item) => (
              <TableRow key={item.id}>
                {headers.map((header) => (
                  <TableCell key={header}>
                    {item[header] !== undefined ? item[header] : "N/A"}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default DamagedEq;
